import React from 'react';

import './AddIcon.css';

const AddIcon = ({ viewBox, className }) => (
  <svg
    className={[
      'AddIcon',
      className,
    ].join(' ')}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
  >
    <path d="M3 0v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2z" />
  </svg>
);

AddIcon.defaultProps = {
  className: "",
  viewBox: "0 0 8 8",
};

export default AddIcon;



// WEBPACK FOOTER //
// ./src/components/UIKit/AddIcon/AddIcon.jsx